var _defs, _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCuffie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0089fb;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.34,39.08c-.42,0-.85-.03-1.28-.08-.77-.1-1.53-.3-2.25-.58-.62-.24-.93-.94-.69-1.56.24-.62.94-.93,1.56-.69.54.21,1.11.36,1.69.43,2.71.36,5.37-.82,6.93-3.06.38-.55,1.13-.68,1.68-.3.55.38.68,1.13.3,1.68-1.83,2.63-4.8,4.16-7.94,4.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.28 35.76 22.98 40.21 22.54 37.41 24.76 35.65 18.28 35.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.78,35.27c.57-.82.37-1.95-.45-2.52s-1.95-.37-2.52.45c-.57.82-.37,1.95.45,2.52s1.95.37,2.52-.45Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.99,30.83c-2.54,0-4.61-2.07-4.61-4.61v-5.11c0-1.25.49-2.41,1.37-3.27.84-.86,2-1.35,3.25-1.35,1.6,0,2.91,1.31,2.91,2.91v8.52c0,1.6-1.3,2.91-2.91,2.91Zm0-11.93c-.59,0-1.14.23-1.54.64-.44.43-.66.97-.66,1.56v5.11c0,1.21.99,2.2,2.2,2.2.27,0,.5-.23.5-.5v-8.52c0-.27-.23-.5-.5-.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35.01,30.83c-1.6,0-2.91-1.31-2.91-2.91v-8.52c0-1.6,1.3-2.91,2.91-2.91,2.54,0,4.61,2.07,4.61,4.61v5.11c0,1.25-.49,2.41-1.37,3.27-.84.86-2,1.35-3.24,1.35Zm0-11.93c-.27,0-.5.23-.5.5v8.52c0,.27.23.5.5.5.59,0,1.14-.23,1.54-.64.44-.43.66-.97.66-1.56v-5.11c0-1.21-.99-2.2-2.2-2.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.72,22.81c-.67,0-1.21-.54-1.21-1.21v-2.3c0-5.24,4.27-9.51,9.51-9.51s9.51,4.27,9.51,9.51c0,0-.54,3.13-1.21,3.13s-1.21-.54-1.21-1.21v-1.93c0-3.91-3.18-7.1-7.1-7.1s-7.1,3.18-7.1,7.1v2.3c0,.67-.54,1.21-1.21,1.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuffie);
export default __webpack_public_path__ + "static/media/cuffie.fe0ba4709ba6d13b75d626ffedfa0d31.svg";
export { ForwardRef as ReactComponent };